<template>
    <FloatingPanel>
        <div class="canvas-blocks-modules-vacancy-overview-BlockPanel">
            <div class="m-5 space-y-2">

                <div class="text-gray-600">Vacatures</div>

                <div>
                    <small class="block mb-1 text-gray-500 text-muted">
                        Hoeveel vacatures wil je maximaal tonen?
                    </small>

                    <input type="number" min="1" step="1"
                        class="focus:border-blue-300 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm border border-gray-300 border-solid ease-in-out mt-1 px-3 py-2 rounded-md shadow-sm transition w-full"
                        v-model="options.limit"
                    />
                </div>

                <div>
                    <small class="block mb-1 text-gray-500 text-muted">
                        Hoe wil je dat de vacatures gesorteerd worden?
                    </small>

                    <select
                           class="focus:border-blue-300 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm border border-gray-300 border-solid ease-in-out mt-1 px-3 py-2 rounded-md shadow-sm transition w-full"
                           v-model="options.sort"
                    >
                        <option value="default">Standaard</option>
                        <option value="latest">Nieuwste eerst</option>
                        <option value="oldest">Laatste eerst</option>
                        <option value="alphabetically">Alfabetisch</option>
                    </select>
                </div>

            </div>

            <div slot="Algemeen">
                <CommonInputs :options="options" />
            </div>
        </div>
    </FloatingPanel>
</template>

<script>
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from '@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs';

export default {
    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
    },

    async mounted()
    {

    },

    data() {

        return {

        };
    },

    methods: {


    }
};
</script>
